import axios from 'axios';
import resolve  from './../resolver.js';
import checkJwt from './../../Global/jwtChecker';
import logout from './../../Global/logout';
import formatDate from './../../Global/formatDate';

export default async function GetReports(    
    startDate, 
    endDate = new Date()
) {

    const unHashedJwt = await checkJwt()

    if(!unHashedJwt){
        logout()
    }

    let queryData = "?start_date="
   
    if(startDate instanceof Date){
        let formatedDate = await formatDate(startDate)
        queryData = queryData + formatedDate.toString()
    }

    if(endDate instanceof Date){
        let formatedDate = await formatDate(endDate)
        queryData = queryData + "&end_date=" + formatedDate.toString()
    }
    
    return await resolve(
        axios( 'client/reports' + queryData, {
            method: 'get',
            headers: { 'Authorization' : unHashedJwt.data}           
        }).then(res => res.data)
        .catch(error => error.response.data)
        );
}